import * as React from "react";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import Stack from "@mui/material/Stack";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

type Props = {
   count: number;
   onChange: (event: React.ChangeEvent<unknown>, value: any) => void;
   key?: any;
};

export default function PaginationMaterial({count, onChange, key}: Props) {
   return (
      <div key={key}>
         <Stack
            spacing={2}
            sx={{
               "& ul, & li": {
                  "&::before": {
                     content: "none"
                  }
               }
            }}
         >
            <Pagination
               count={count}
               sx={{
                  "& .Mui-selected": {
                     backgroundColor: "#F9B233",
                     color: "#fff !important"
                  },
                  "& .MuiPaginationItem-root": {
                     color: "#000000ba"
                  }
               }}
               defaultValue={1}
               onChange={(e, value) => onChange(e, value)}
               renderItem={(item) => (
                  <PaginationItem
                     slots={{previous: ArrowBackIcon, next: ArrowForwardIcon}}
                     {...item}
                  />
               )}
            />
         </Stack>
      </div>
   );
}
